<template>
  <div>
    <b-card class="col-12" no-body>
      <div class="m-2">
        <b-row>
          <b-col cols="12">
            <h4>Tạo đơn thương mại điện tử</h4>
          </b-col>
        </b-row>
        <b-row class="mt-2">
          <b-col cols="12" md="6">
            <b-form-group class="mb-0">
              <div class="form-custom-horizontal">
                <label class="form-custom-label">
                  Kênh TMĐT <span class="text-primary">*</span>
                </label>
                <Select2
                    v-model="selectedEcomerceChannel"
                    :options="
                    ecommerceChannelList.map(el => {
                      return { id: el.Id, text: el.Name };
                    })
                  "
                    :settings="{}"
                    placeholder="Chọn kênh"
                    style="width: 250px"
                />
              </div>
            </b-form-group>
          </b-col>
          <b-col cols="12" md="6">
            <div class="float-right d-flex h-100">
              <b-button
                  class="text-nowrap mr-2"
                  size="sm"
                  variant="primary"
                  @click="onOpenModalWeb"
              >
                Kho số website
              </b-button>
              <b-button
                  class="text-nowrap mr-2"
                  size="sm"
                  variant="primary"
                  @click="onOpenModalFree"
              >
                Kho số 0đ
              </b-button>
              <b-button
                  class="text-nowrap mr-2"
                  size="sm"
                  variant="primary"
                  @click="onOpenModalSimAndPack"
              >
                Sim + gói cước
              </b-button>
              <b-button
                  class="text-nowrap mr-2"
                  size="sm"
                  variant="primary"
                  @click="onOpenModalTMDT"
              >
                Kho số TMĐT
              </b-button>
              <b-button
                  class="text-nowrap mr-2"
                  size="sm"
                  variant="primary"
                  @click="onOpenModalImportFile()"
              >
                Import File
              </b-button>
              <b-button
                  class="text-nowrap"
                  size="sm"
                  variant="primary"
                  @click="onOpenModalImportHistory"
              >
                Lịch sử Import
              </b-button>
            </div>
          </b-col>
        </b-row>
        <b-row class="mt-2">
          <b-col cols="12">
            <h5>Danh sách số</h5>
          </b-col>
          <b-col class="mt-1" cols="12">
            <!-- @on-page-change="onPageChange"
                        @on-sort-change="onSortChange"
                        @on-column-filter="onColumnFilter"
                        @on-per-page-change="onPerPageChange" -->
            <vue-good-table
                :columns="fields"
                :line-numbers="true"
                :pagination-options="{
                perPage: serverParams.pageSize,
                enabled: true,
                perPageDropdown: [20, 50, 100],
                dropdownAllowAll: false
              }"
                :rows="rows"
                :totalRows="totalRecords"
                mode="remote"
            >
              <template slot="table-row" slot-scope="props">
                <div
                    v-if="props.column.field === 'action'"
                    class="d-flex justify-content-center"
                >
                  <feather-icon
                      class="mr-50 cursor-pointer"
                      icon="Trash2Icon"
                      @click="deletePhone(props.row.Phone, props.row.uuid)"
                  />
                </div>
                <div
                    v-else-if="props.column.field === 'IsEsim'"
                    class="d-flex justify-content-center"
                >
                  <b-form-checkbox v-model="props.row.IsEsim" disabled>
                  </b-form-checkbox>
                </div>
                <div v-else-if="props.column.field === 'Source'">
                  {{
                  props.row.Source == 1
                  ? "Kho online"
                  : props.row.Source == 2
                  ? "Kho 0 đồng"
                  : props.row.Source == 3
                  ? "Sim + gói cước"
                  : "Kho TMĐT"
                  }}
                </div>
                <span v-else>
                  {{ props.formattedRow[props.column.field] }}
                </span>
              </template>
            </vue-good-table>
          </b-col>
        </b-row>
        <b-row class="mt-2">
          <b-col cols="12">
            <h5>Thông tin khách hàng</h5>
          </b-col>
        </b-row>
        <validation-observer ref="modalCustomerInfo">
          <b-row class="mt-2">
            <b-col lg="6" md="6" sm="12">
              <validation-provider #default="{ errors }" rules="required">
                <b-form-group>
                  <label>
                    Tên khách hàng <span class="text-primary">*</span>
                  </label>
                  <b-form-input v-model="customerInfo.FullName" size="sm"/>
                </b-form-group>
                <div class="error-txt">
                  <small v-if="errors.length > 0"
                  >Tên khách hàng không hợp lệ</small
                  >
                </div>
              </validation-provider>
            </b-col>
            <b-col lg="6" md="6" sm="12">
              <validation-provider
                  #default="{ errors }"
                  rules="required|phoneNumber"
              >
                <b-form-group>
                  <label>
                    Số liên hệ <span class="text-primary">*</span>
                  </label>
                  <b-form-input v-model="customerInfo.ContactPhone" size="sm"/>
                </b-form-group>
                <div class="error-txt">
                  <small v-if="errors.length > 0"
                  >Số điện thoại không hợp lệ</small
                  >
                </div>
              </validation-provider>
            </b-col>
            <b-col v-if="rows.find(el => el.IsEsim)" lg="12" md="12" sm="12">
              <validation-provider #default="{ errors }" rules="required|email">
                <b-form-group>
                  <label> Email <span class="text-primary">*</span> </label>
                  <b-form-input v-model="customerInfo.Email" size="sm"/>
                </b-form-group>
                <div class="error-txt">
                  <small v-if="errors.length > 0">Email không hợp lệ</small>
                </div>
              </validation-provider>
            </b-col>
            <b-col lg="12" md="12" sm="12">
              <validation-provider #default="{ errors }" rules="required">
                <b-form-group>
                  <label> Địa chỉ <span class="text-primary">*</span> </label>
                  <b-form-input v-model="customerInfo.Address" size="sm"/>
                </b-form-group>
                <div class="error-txt">
                  <small v-if="errors.length > 0">Địa chỉ không hợp lệ</small>
                </div>
              </validation-provider>
            </b-col>
            <b-col lg="12" md="12" sm="12">
              <validation-provider #default="{ errors }" rules="">
                <b-form-group>
                  <label> Ghi chú </label>
                  <b-form-input v-model="customerInfo.Note" size="sm"/>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col lg="12" md="12" sm="12">
              <validation-provider #default="{ errors }" rules="">
                <b-form-group>
                  <label> Tổng tiền </label>
                  <b-form-input
                      v-model="customerInfo.Total"
                      disabled
                      size="sm"
                  />
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>
        </validation-observer>
        <b-row class="mt-2">
          <b-col class="d-flex justify-content-end" cols="12">
            <b-button class="btn" variant="primary" @click="onOrder()" :disabled="isLoading">
              Đặt đơn
            </b-button>
            <b-button class="btn" variant="secondary ml-1"> Hủy</b-button>
          </b-col>
        </b-row>
      </div>
    </b-card>
    <b-modal
        id="modal-store-website"
        cancel-title="Hủy"
        centered
        ok-title="Thêm số"
        size="md"
        title="Thêm số"
        @ok="onAddStoreSim($event)"
    >
      <validation-observer ref="modalStoreWebsite">
        <b-row class="mt-2">
          <b-col
              class="d-flex align-items-end mb-1"
              lg="8"
              md="8"
              sm="12"
              style="gap: 8px"
          >
            <validation-provider #default="{ errors }" rules="required">
              <b-form-group class="mb-0">
                <label> Số thuê bao <span class="text-primary">*</span> </label>
                <b-form-input v-model="websiteForm.Phone" size="sm"/>
              </b-form-group>
            </validation-provider>
            <b-button
                class="btn"
                size="sm"
                variant="primary"
                @click="openChooseSimPopup()"
            >
              Chọn số
            </b-button>
          </b-col>
          <b-col
              class="d-flex align-items-end mb-1"
              lg="4"
              md="4"
              sm="12"
              style="gap: 8px"
          >
            <span>Sử dụng Esim</span>
            <b-form-checkbox
                v-model="websiteForm.IsEsim"
                @change="onStoreEsimCheckChange()"
            ></b-form-checkbox>
          </b-col>
          <b-col lg="6" md="6" sm="12">
            <validation-provider #default="{ errors }" rules="">
              <b-form-group>
                <label> Giá số </label>
                <b-form-input v-model="websiteForm.Price" disabled size="sm"/>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col lg="6" md="6" sm="12">
            <validation-provider #default="{ errors }" rules="">
              <b-form-group>
                <label> Giá {{ websiteForm.IsEsim ? "Esim" : "sim" }} </label>
                <b-form-input
                    v-model="websiteForm.SimPrice"
                    disabled
                    size="sm"
                />
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col lg="6" md="6" sm="12">
            <validation-provider #default="{ errors }" rules="">
              <b-form-group>
                <label> Gói cước </label>
                <b-form-input v-model="websiteForm.Pack" disabled size="sm"/>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col lg="6" md="6" sm="12">
            <validation-provider #default="{ errors }" rules="">
              <b-form-group>
                <label> Giá gói </label>
                <b-form-input
                    v-model="websiteForm.PackPrice"
                    disabled
                    size="sm"
                />
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col lg="6" md="6" sm="12">
            <validation-provider #default="{ errors }" rules="">
              <b-form-group>
                <label> Tháng cam kết </label>
                <b-form-input
                    v-model="websiteForm.ThoiGianCamKet"
                    disabled
                    size="sm"
                />
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col lg="6" md="6" sm="12">
            <validation-provider #default="{ errors }" rules="">
              <b-form-group>
                <label> Loại số </label>
                <b-form-input
                    v-model="websiteForm.SimType"
                    disabled
                    size="sm"
                />
              </b-form-group>
            </validation-provider>
          </b-col>
        </b-row>
      </validation-observer>
    </b-modal>
    <b-modal
        id="modal-store-free"
        cancel-title="Hủy"
        centered
        ok-title="Thêm số"
        size="xl"
        title="Thêm số"
        @ok="onAddFreeSim($event)"
    >
      <b-row class="mb-2">
        <b-col cols="12" md="12">
          <div class="float-right d-flex h-100">
            <!--<b-button size="md" class="text-nowrap mr-2" variant="primary"
                            @click="onOpenModalImportPhone('0D')">
                            + Import
                        </b-button>--->
            <b-button
                class="text-nowrap"
                size="md"
                variant="primary"
                @click="onOpenModalExportPhone('0D')"
            >
              + Export
            </b-button>
          </div>
        </b-col>
      </b-row>
      <vue-good-table
          :columns="fieldsFreeSim"
          :line-numbers="true"
          :pagination-options="{
          perPage: serverParamsListFreeSim.pageSize,
          enabled: true,
          perPageDropdown: [20, 50, 100],
          dropdownAllowAll: false
        }"
          :rows="listFreeSim"
          :totalRows="totalsFreeSim"
          mode="remote"
          @on-page-change="onPageChangeFreeStore"
          @on-sort-change="onSortChangeFreeStore"
          @on-column-filter="onColumnFilterFreeStore"
          @on-per-page-change="onPerPageChangeFreeStore"
      >
        <template slot="table-row" slot-scope="props">
          <div
              v-if="props.column.field === 'action'"
              class="d-flex justify-content-center"
          >
            <b-form-checkbox
                :checked="props.row.selected"
                :disabled="props.row.Status != 0"
                @change="onSelectFreeSim(props.row.Phone)"
            />
          </div>
          <div v-else-if="props.column.field === 'Esim'">
            {{ !!props.row.Esim ? "Esim" : "Usim" }}
          </div>
          <div v-else-if="props.column.field === 'Status'">
            {{
            props.row.Status == 0
            ? "Sẵn sàng"
            : props.row.Status == 1
            ? "Đã bán - chưa kích hoạt"
            : props.row.Status == 2
            ? "Đã bán - đã kích hoạt"
            : props.row.Status == 10
            ? "iTel giữ số"
            : props.row.Status == 11
            ? "Lỗi VnPay, chờ kiểm tra"
            : ""
            }}
          </div>
          <div v-else-if="props.column.field === 'Tags'">
            <div class="tags-container">
              <template v-for="(el, index) in props.row.Tags">
                <div :key="index" class="tag-item">
                  {{ el }}
                </div>
              </template>
            </div>
          </div>
          <div
              v-else-if="props.column.field === 'handle'"
              class="d-flex justify-content-center"
          >
            <feather-icon
                v-if="props.row.Status == 0 || props.row.Status == 10"
                class="cursor-pointer"
                icon="Edit2Icon"
                @click="onChangeStatusPhone('0D', props.row.Phone)"
            />
          </div>
          <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>
        </template>
      </vue-good-table>
    </b-modal>
    <b-modal
        id="modal-store-tmdt"
        cancel-title="Hủy"
        centered
        ok-title="Thêm số"
        size="xl"
        title="Thêm số"
        @ok="onAddTMDTSim($event)"
    >
      <b-row class="mb-2">
        <b-col cols="12" md="12">
          <div class="float-right d-flex h-100">
            <!--<b-button size="md" class="text-nowrap mr-2" variant="primary"
                            @click="onOpenModalImportPhone('TMDT')">
                            + Import
                        </b-button>--->
            <b-button
                class="text-nowrap"
                size="md"
                variant="primary"
                @click="onOpenModalExportPhone('TMDT')"
            >
              + Export
            </b-button>
          </div>
        </b-col>
      </b-row>
      <vue-good-table
          :columns="fieldsTMDTSim"
          :line-numbers="true"
          :pagination-options="{
          perPage: serverParamsListTMDTSim.pageSize,
          enabled: true,
          perPageDropdown: [20, 50, 100],
          dropdownAllowAll: false
        }"
          :rows="listTMDTSim"
          :totalRows="totalsTMDT"
          mode="remote"
          @on-page-change="onPageChangeTMDTStore"
          @on-sort-change="onSortChangeTMDTStore"
          @on-column-filter="onColumnFilterTMDTStore"
          @on-per-page-change="onPerPageChangeTMDTStore"
      >
        <template slot="table-row" slot-scope="props">
          <div
              v-if="props.column.field === 'action'"
              class="d-flex justify-content-center"
          >
            <b-form-checkbox
                :checked="props.row.selected"
                :disabled="props.row.Status != 0"
                @change="onSelectTMDTSim(props.row.Phone)"
            />
          </div>
          <div
              v-else-if="props.column.field === 'Esim'"
              class="d-flex justify-content-center"
          >
            <b-form-checkbox
                :checked="!!props.row.Esim"
                :disabled="!!props.row.disabled"
                @change="onChangeSimTypeSim(props.row.Phone)"
            />
          </div>
          <div v-else-if="props.column.field === 'Status'">
            {{
            props.row.Status == 0
            ? "Sẵn sàng"
            : props.row.Status == 1
            ? "Đã bán - chưa kích hoạt"
            : props.row.Status == 2
            ? "Đã bán - đã kích hoạt"
            : props.row.Status == 10
            ? "iTel giữ số"
            : props.row.Status == 11
            ? "Lỗi VnPay, chờ kiểm tra"
            : ""
            }}
          </div>
          <div v-else-if="props.column.field === 'Tags'">
            <div class="tags-container">
              <template v-for="(el, index) in props.row.Tags">
                <div :key="index" class="tag-item">
                  {{ el }}
                </div>
              </template>
            </div>
          </div>
          <div
              v-else-if="props.column.field === 'handle'"
              class="d-flex justify-content-center"
          >
            <feather-icon
                v-if="props.row.Status == 0 || props.row.Status == 10"
                class="cursor-pointer"
                icon="Edit2Icon"
                @click="onChangeStatusPhone('TMDT', props.row.Phone)"
            />
          </div>
          <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>
        </template>
      </vue-good-table>
    </b-modal>

    <b-modal
        id="modal-order-success"
        centered
        hide-footer
        hide-header
        size="md"
        @hide="resetOrderData()"
    >
      <div class="p-2">
        <div class="d-flex justify-content-center">
          <svg
              fill="none"
              height="120"
              viewBox="0 0 120 120"
              width="120"
              xmlns="http://www.w3.org/2000/svg"
          >
            <path
                d="M117.143 54.7756V60.0327C117.136 72.3551 113.146 84.3451 105.768 94.2146C98.3895 104.084 88.0188 111.304 76.202 114.798C64.3853 118.292 51.7558 117.872 40.197 113.602C28.6382 109.331 18.7695 101.439 12.0626 91.1017C5.35581 80.7643 2.17024 68.5359 2.98101 56.2402C3.79179 43.9445 8.55547 32.2403 16.5616 22.8731C24.5677 13.506 35.3873 6.97775 47.4068 4.26212C59.4262 1.54648 72.0015 2.78892 83.2572 7.80414M117.143 14.3185L60 71.5185L42.8571 54.3756"
                stroke="#40E108"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="4"
            />
          </svg>
        </div>
        <h2
            class="huge-text text-center mt-2 font-weight-bold"
            style="color: #424242"
        >
          Đặt đơn thành công
        </h2>
        <p class="text-center">
          Mã đơn hàng:
          <span style="font-weight: 600">{{ this.successOrderId }}</span>
        </p>
      </div>
    </b-modal>
    <b-modal
        id="modal-sim-and-pack"
        cancel-title="Hủy"
        centered
        ok-title="Thêm số"
        size="lg"
        title="Thêm sản phẩm"
        @ok="onAddSimAndPack($event)"
    >
      <vue-good-table
          :columns="fieldsSimAndPack"
          :line-numbers="true"
          :pagination-options="{
          perPage: serverParamsListSimAndPack.pageSize,
          enabled: true,
          perPageDropdown: [20, 50, 100],
          dropdownAllowAll: false
        }"
          :rows="listSimAndPack"
          :totalRows="listSimAndPack.length"
          mode="remote"
          @on-page-change="onPageChangeSimAndPack"
          @on-sort-change="onSortChangeSimAndPack"
          @on-column-filter="onColumnFilterSimAndPack"
          @on-per-page-change="onPerPageChangeSimAndPack"
      >
        <template slot="table-row" slot-scope="props">
          <div
              v-if="props.column.field === 'Quantity'"
              class="d-flex justify-content-center"
          >
            <b-form-input
                v-model.number="props.row.Quantity"
                :min="0"
                :type="'number'"
                @change="onSimAndPackQuantityChange($event, props.row.uuid)"
            />
          </div>
          <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>
        </template>
      </vue-good-table>
    </b-modal>
    <b-modal
        id="modal-import-excel"
        :title="'Import File'"
        cancel-title="Hủy"
        centered
        ok-title="Đặt đơn"
        size="md"
        @ok="importExcelOk"
    >
      <b-row>
        <b-col cols="12">
          <b-button
              class="btn-sm mr-50"
              style="color: black"
              variant="outline-primary"
              @click="$refs.inputImportExcelFile.click()"
          >
            <feather-icon class="align-text-top" icon="UploadIcon" size="16"/>
            Upload file
          </b-button>
          <span v-if="file && file.name">{{ file.name }}</span>
          <span v-else style="color: #ed1f24">Vui lòng chọn file!</span>
          <input
              ref="inputImportExcelFile"
              accept=".xls*"
              class="fileSelect"
              style="display: none"
              type="file"
              @change="handleChange($event)"
          />
        </b-col>
        <b-col class="mt-2" cols="12">
          <button
              class="btn btn-sm mr-50 btn-outline-primary m-0"
              style="color: black"
              @click="downloadTemplate()"
          >
            <feather-icon
                class="align-text-top"
                icon="DownloadIcon"
                size="16"
            />
            Tải file mẫu
          </button>
        </b-col>
      </b-row>
      <template #modal-footer>
        <button
            v-if="fileResult"
            class="btn mr-50 btn-outline-primary m-0"
            style="color: red"
            @click="downloadResult()"
        >
          Tải kết quả
        </button>
        <b-button
            class=""
            variant=""
            @click="$bvModal.hide('modal-import-excel')"
        >Cancel
        </b-button>
        <b-button class="ml-1" variant="primary" @click="importExcelOk" :disabled="isLoading"
        >Đặt đơn
        </b-button>
      </template>
    </b-modal>
    <b-modal
        id="modal-import-history"
        :title="'Import File'"
        ok-only
        ok-title="Đóng"
        size="lg"
    >
      <vue-good-table
          :columns="fieldsImportHistory"
          :line-numbers="true"
          :rows="listSimHistory"
          :totalRows="100"
          mode="remote"
          @on-page-change="onPageChangeSimHistory"
          @on-per-page-change="onPerPageChangeSimHistory"
      >
        <template slot="table-row" slot-scope="props">
          <div
              v-if="props.column.field === 'Action'"
              class="d-flex justify-content-around"
          >
            <b-button
                class="text-nowrap"
                size="sm"
                variant="primary"
                @click="PrintImport(props.row.Id)"
            >
              In tem
            </b-button>
            <b-button
                class="text-nowrap"
                size="sm"
                variant="primary"
                @click="DownloadImport(props.row.Id)"
            >
              Tải file
            </b-button>
          </div>
        </template>
      </vue-good-table>
    </b-modal>
    <b-modal
        id="modal-import-phone"
        :title="'Import File'"
        cancel-title="Hủy"
        centered
        ok-title="Tải lên"
        size="md"
        @ok="onUploadFile()"
    >
      <b-row>
        <b-col cols="12">
          <b-button
              class="btn-sm mr-50"
              style="color: black"
              variant="outline-primary"
              @click="$refs.inputImportExcelFile.click()"
          >
            <feather-icon class="align-text-top" icon="UploadIcon" size="16"/>
            Upload file
          </b-button>
          <span v-if="file && file.name">{{ file.name }}</span>
          <span v-else style="color: #ed1f24">Vui lòng chọn file!</span>
          <input
              ref="inputImportExcelFile"
              accept=".xls*"
              class="fileSelect"
              style="display: none"
              type="file"
              @change="handleChange($event)"
          />
        </b-col>
        <b-col class="mt-2" cols="12">
          <button
              class="btn btn-sm mr-50 btn-outline-primary m-0"
              style="color: black"
              @click="downloadListPhoneTemplate('/fileExcel/phoneTemplate.xlsx')"
          >
            <feather-icon
                class="align-text-top"
                icon="DownloadIcon"
                size="16"
            />
            Tải file mẫu
          </button>
        </b-col>
      </b-row>
    </b-modal>
    <b-modal
        id="modal-change-status-phone"
        cancel-title="Hủy"
        centered
        ok-title="Cập nhật"
        size="md"
        title="Thay đổi trạng thái số"
        @ok="onUpdatePhoneStatus($event)"
    >
      <validation-observer ref="modalChangeStatus">
        <b-row>
          <b-col lg="12" md="12" sm="12">
            <validation-provider #default="{ errors }" rules="">
              <b-form-group>
                <label> Trạng thái mới </label>
                <Select2
                    v-model="changeStatusInfo.status"
                    :options="listStatus"
                    :settings="{}"
                    style="width: 250px"
                />
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col lg="12" md="12" sm="12">
            <validation-provider #default="{ errors }" rules="">
              <b-form-group>
                <label> Tags </label>
                <b-form-tags
                    v-model="changeStatusInfo.tags"
                    input-id="tags-basic"
                    placeholder="..."
                ></b-form-tags>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col lg="12" md="12" sm="12">
            <validation-provider #default="{ errors }" rules="">
              <b-form-group>
                <label> Ghi chú </label>
                <b-form-textarea
                    v-model="changeStatusInfo.note"
                    max-rows="6"
                    rows="3"
                    size="sm"
                />
              </b-form-group>
            </validation-provider>
          </b-col>
        </b-row>
      </validation-observer>
    </b-modal>
    <b-modal
        id="modal-export-phone"
        cancel-title="Hủy"
        centered
        ok-title="Tải xuống"
        size="md"
        title="Export file"
        @ok="onExportPhoneFile($event)"
    >
      <div>
        <div class="group-number-of-phone">
          <div class="number-label">Số lượng</div>
          <b-form-input
              v-model="exportNumber"
              min="1"
              size="sm"
              type="number"
          />
        </div>
        <div class="export-phone-note mt-1">
          <span class="text-note"> Lưu ý: </span>
          Trường hợp không nhập số lượng sẽ tải về danh sách theo bộ lọc trước
          đó.
        </div>
      </div>
    </b-modal>
    <PopupChoosePhone
        :modalSrc="
        $ctx.URL_FRONTEND + '/mua-hang?iframe=true&type=tmdt&isChooseSim=true'
      "
        modalId="popupChooseSim"
    />
  </div>
</template>
<script>
import {
  BButton,
  BCard,
  BCol,
  BDropdown,
  BDropdownItem,
  BFormCheckbox,
  BFormGroup,
  BFormInput,
  BFormTags,
  BFormTextarea,
  BModal,
  BRow
} from "bootstrap-vue";
import {extend, ValidationObserver, ValidationProvider} from "vee-validate";
import Select2 from "v-select2-component";
import FeatherIcon from "@/@core/components/feather-icon/FeatherIcon.vue";
import {VueGoodTable} from "vue-good-table";
import "@core/scss/vue/libs/vue-good-table.scss";
import {email, required} from "@validations";
import PopupChoosePhone from "./PopupChoosePhone.vue";
import {$ctx} from "@themeConfig";
import useJwt from "@/auth/jwt/useJwt";
import {v4 as uuidv4} from "uuid";
import {read, utils, writeFile} from "xlsx";
import useOdata from "@core/auth/odata/useOdata";
import moment from "moment";

extend("phoneNumber", value => {
  if (value.length < 10 || value.length > 11) return false;
  return true;
});

function getStatusText(num) {
  const statusList = [
    {value: "0", text: "Sẵn sàng"},
    {value: "1", text: "Đã bán - chưa kích hoạt"},
    {value: "2", text: "Đã bán - đã kích hoạt"},
    {value: "10", text: "iTel giữ số"},
    {value: "11", text: "Lỗi VnPay, chờ kiểm tra"},
    {value: "99", text: "Tất cả"}
  ];

  let status = statusList.find(el => el.value == num);
  return status ? status.text : "";
}

export default {
  components: {
    BRow,
    BCol,
    BCard,
    Select2,
    BFormGroup,
    BButton,
    FeatherIcon,
    VueGoodTable,
    BFormCheckbox,
    BDropdownItem,
    BDropdown,
    ValidationProvider,
    ValidationObserver,
    BFormInput,
    BModal,
    PopupChoosePhone,
    BFormTextarea,
    BFormTags
  },
  computed: {
    $ctx() {
      return $ctx;
    }
  },
  mounted() {
    // Listen to message from child window
    window.addEventListener("message", this.handleMessageEventer, false);
    this.loadListEcommerceChannel();
    this.loadListFreeSim();
    this.loadListSimAndPack();
    this.loadListTMDTSim();
    if (this.getCookie("e-commerce-info")) {
      const oldInfo = JSON.parse(this.getCookie("e-commerce-info"));
      this.customerInfo = {
        FullName: oldInfo?.FullName || this.customerInfo.FullName,
        ContactPhone: oldInfo?.ContactPhone || this.customerInfo.ContactPhone,
        Email: oldInfo?.Email || this.customerInfo.Email,
        Address: oldInfo?.Address || this.customerInfo.Address,
        Note: oldInfo?.Note || this.customerInfo.Note,
        Total: this.customerInfo.Total
      };
    }
  },
  watch: {
    rows: {
      handler: function (newValue) {
        this.customerInfo.Total = this.rows.reduce((total, current) => {
          return (
              total +
              (current.PackPrice + current.Price + current.SimPrice) *
              (+current.Quantity || 1)
          );
        }, 0);
      },
      deep: true
    }
  },
  beforeDestroy() {
    window.removeEventListener("message", this.handleMessageEventer);
  },
  data: () => {
    return {
      required,
      email,
      ecommerceChannelList: [],
      selectedEcomerceChannel: "",
      totalRecords: 0,
      isLoading: false,
      serverParams: {
        columnFilters: {},
        sort: [],
        page: 1,
        pageSize: 50,
        lang: 1
      },
      serverParamsListFreeSim: {
        columnFilters: {},
        sort: [],
        page: 1,
        pageSize: 50,
        lang: 1
      },
      serverParamsListTMDTSim: {
        columnFilters: {},
        sort: [],
        page: 1,
        pageSize: 50,
        lang: 1
      },
      serverParamsListSimAndPack: {
        columnFilters: {},
        sort: [],
        page: 1,
        pageSize: 50,
        lang: 1
      },
      serverParamsListSimHistory: {
        columnFilters: {},
        sort: [],
        page: 1,
        pageSize: 50,
        lang: 1
      },
      rows: [],
      fields: [
        {
          field: "Phone",
          filterOptions: {enabled: true, placeholder: "", trigger: "enter"},
          label: "Số thuê bao",
          width: "130px"
        },
        {
          field: "Msin",
          filterOptions: {enabled: true, placeholder: "", trigger: "enter"},
          label: "Msin",
          width: "110px"
        },
        {
          field: "Price",
          filterOptions: {enabled: true, placeholder: "", trigger: "enter"},
          tdClass: "text-right",
          label: "Giá số",
          width: "100px"
        },
        {
          field: "SimPrice",
          filterOptions: {enabled: true, placeholder: "", trigger: "enter"},
          tdClass: "text-right",
          label: "Giá sim"
        },
        {
          field: "Pack",
          filterOptions: {enabled: true, placeholder: "", trigger: "enter"},
          label: "Gói cước",
          tdClass: "text-center",
          width: "100px"
        },
        {
          field: "PackPrice",
          filterOptions: {enabled: true, placeholder: "", trigger: "enter"},
          label: "Giá gói",
          tdClass: "text-right",
          width: "90px"
        },
        {
          field: "ThoiGianCamKet",
          filterOptions: {enabled: true, placeholder: "", trigger: "enter"},
          tdClass: "text-right",
          label: "Tháng cam kết"
        },
        {
          field: "SimType",
          filterOptions: {enabled: true, placeholder: "", trigger: "enter"},
          label: "Loại số",
          tdClass: "text-center",
          width: "110px"
        },
        {
          field: "IsEsim",
          filterOptions: {enabled: false, placeholder: "", trigger: "enter"},
          label: "Esim",
          tdClass: "text-center",
          width: "50px"
        },
        {
          field: "Source",
          filterOptions: {enabled: true, placeholder: "", trigger: "enter"},
          label: "Kho số"
        },
        {
          field: "Quantity",
          filterOptions: {enabled: true, placeholder: "", trigger: "enter"},
          label: "Số lượng",
          tdClass: "text-center"
        },
        {field: "action", label: "Thao tác", width: "80px"}
      ],
      fieldsFreeSim: [
        {
          field: "Phone",
          filterOptions: {enabled: true, placeholder: "", trigger: "enter"},
          label: "Số thuê bao",
          width: "130px"
        },
        {
          field: "Msin",
          filterOptions: {enabled: true, placeholder: "", trigger: "enter"},
          label: "Msin"
        },
        {
          field: "Price",
          filterOptions: {enabled: true, placeholder: "", trigger: "enter"},
          tdClass: "text-right",
          label: "Giá số",
          width: "100px"
        },
        {
          field: "SimPrice",
          filterOptions: {enabled: true, placeholder: "", trigger: "enter"},
          tdClass: "text-right",
          label: "Giá sim"
        },
        {
          field: "EsimPrice",
          filterOptions: {enabled: true, placeholder: "", trigger: "enter"},
          tdClass: "text-right",
          label: "Giá Esim"
        },
        {
          field: "Pack",
          filterOptions: {enabled: true, placeholder: "", trigger: "enter"},
          label: "Gói cước",
          tdClass: "text-center",
          width: "100px"
        },
        {
          field: "PackPrice",
          filterOptions: {enabled: true, placeholder: "", trigger: "enter"},
          label: "Giá gói",
          tdClass: "text-right",
          width: "90px"
        },
        {
          field: "SimType",
          filterOptions: {enabled: true, placeholder: "", trigger: "enter"},
          label: "Loại số",
          tdClass: "text-right",
          width: "80px"
        },
        {
          field: "Months",
          filterOptions: {enabled: true, placeholder: "", trigger: "enter"},
          label: "Cam kết",
          tdClass: "text-right",
          width: "80px"
        },
        {
          field: "Status",
          filterOptions: {
            enabled: true,
            placeholder: "",
            filterDropdownItems: [
              {value: "0", text: "Sẵn sàng"},
              {value: "1", text: "Đã bán - chưa kích hoạt"},
              {value: "2", text: "Đã bán - đã kích hoạt"},
              {value: "10", text: "iTel giữ số"},
              {value: "11", text: "Lỗi VnPay, chờ kiểm tra"},
              {value: "99", text: "Tất cả"}
            ]
          },
          label: "Trạng thái",
          tdClass: "text-center",
          width: "100px",
          dataFormat: getStatusText
        },
        {
          field: "Tags",
          filterOptions: {enabled: true, placeholder: "", trigger: "enter"},
          label: "Tag số",
          tdClass: "text-right",
          width: "150px"
        },
        {
          field: "Esim",
          filterOptions: {
            enabled: true,
            placeholder: "",
            filterDropdownItems: [
              {value: "0", text: "All"},
              {value: "1", text: "Usim"},
              {value: "2", text: "Esim"}
            ]
          },
          label: "Loại sim",
          tdClass: "text-center",
          width: "80px"
        },
        {field: "action", label: "Chọn số", width: "80px"},
        {field: "handle", label: "Thao tác", width: "80px"}
      ],
      fieldsTMDTSim: [
        {
          field: "Phone",
          filterOptions: {enabled: true, placeholder: "", trigger: "enter"},
          label: "Số thuê bao",
          width: "130px"
        },
        {
          field: "Msin",
          filterOptions: {enabled: true, placeholder: "", trigger: "enter"},
          label: "Msin"
        },
        {
          field: "Price",
          filterOptions: {enabled: true, placeholder: "", trigger: "enter"},
          tdClass: "text-right",
          label: "Giá số",
          width: "60px"
        },
        {
          field: "SimPrice",
          filterOptions: {enabled: true, placeholder: "", trigger: "enter"},
          tdClass: "text-right",
          label: "Giá sim"
        },
        {
          field: "EsimPrice",
          filterOptions: {enabled: true, placeholder: "", trigger: "enter"},
          tdClass: "text-right",
          label: "Giá Esim"
        },
        {
          field: "Pack",
          filterOptions: {enabled: true, placeholder: "", trigger: "enter"},
          label: "Gói cước",
          tdClass: "text-center",
          width: "100px"
        },
        {
          field: "PackPrice",
          filterOptions: {enabled: true, placeholder: "", trigger: "enter"},
          label: "Giá gói",
          tdClass: "text-right",
          width: "60px"
        },
        {
          field: "SimType",
          filterOptions: {enabled: true, placeholder: "", trigger: "enter"},
          label: "Loại số",
          tdClass: "text-right",
          width: "80px"
        },
        {
          field: "Months",
          filterOptions: {enabled: true, placeholder: "", trigger: "enter"},
          label: "Cam kết",
          tdClass: "text-right",
          width: "80px"
        },
        {
          // field: function (rowObj) {
          //   return rowObj["Kol"] ? rowObj["Kol"] : "";
          // },
          field: "Kol",
          filterOptions: {
            enabled: true,
            placeholder: "",
            filterDropdownItems: [
              {value: 0, text: "0"},
              {value: 1, text: "1"},
              {value: "", text: "Tất cả"}
            ]
          },
          label: "KOL/KOC",
          tdClass: "text-right",
          width: "90px"
        },
        {
          field: "Status",
          filterOptions: {
            enabled: true,
            placeholder: "",
            filterDropdownItems: [
              {value: "0", text: "Sẵn sàng"},
              {value: "1", text: "Đã bán - chưa kích hoạt"},
              {value: "2", text: "Đã bán - đã kích hoạt"},
              {value: "10", text: "iTel giữ số"},
              {value: "11", text: "Lỗi VnPay, chờ kiểm tra"},
              {value: "99", text: "Tất cả"}
            ]
          },
          label: "Trạng thái",
          tdClass: "text-center",
          width: "100px",
          dataFormat: getStatusText
        },
        {
          field: "Tags",
          filterOptions: {enabled: true, placeholder: "", trigger: "enter"},
          label: "Tag số",
          tdClass: "text-right",
          width: "150px"
        },
        {
          field: "Esim",
          filterOptions: {
            enabled: true,
            placeholder: "",
            filterDropdownItems: [
              {value: "2", text: "All"},
              {value: "0", text: "Usim"},
              {value: "1", text: "Esim"}
            ]
          },
          label: "Esim?",
          tdClass: "text-center",
          width: "80px"
        },
        {field: "action", label: "Chọn số", width: "80px"},
        {field: "handle", label: "Thao tác", width: "80px"}
      ],
      fieldsSimAndPack: [
        {
          field: "Pack",
          filterOptions: {enabled: true, placeholder: "", trigger: "enter"},
          label: "Gói",
          tdClass: "text-center",
          width: "100px"
        },
        {
          field: "PackPrice",
          filterOptions: {enabled: true, placeholder: "", trigger: "enter"},
          label: "Giá gói",
          tdClass: "text-right",
          width: "90px"
        },
        {
          field: "SimPrice",
          filterOptions: {enabled: true, placeholder: "", trigger: "enter"},
          tdClass: "text-right",
          label: "Giá sim",
          width: "100px"
        },
        {
          field: "Type",
          filterOptions: {enabled: true, placeholder: "", trigger: "enter"},
          label: "Loại sim",
          tdClass: "text-center",
          width: "110px"
        },
        {field: "Quantity", label: "Số lượng"}
      ],
      fieldsImportHistory: [
        {
          field: "Account",
          label: "Người nhập",
          tdClass: "text-center"
        },
        {
          field: "ImportDate",
          label: "Ngày nhập",
          tdClass: "text-center"
        },
        {
          field: "OrderCount",
          label: "Số đơn",
          tdClass: "text-center"
        },
        {
          field: "SIMCount",
          label: "Số SIM",
          tdClass: "text-center"
        },
        {
          field: "SIMKittedCount",
          label: "Số SIM đã ghép",
          tdClass: "text-center"
        },
        {
          field: "Action",
          label: "Thao tác",
          tdClass: "text-center"
        }
      ],
      websiteForm: {
        IsEsim: false,
        Phone: "",
        msin: "",
        Price: 0,
        SimPrice: 0,
        Pack: "",
        PackPrice: "",
        ThoiGianCamKet: 0,
        SimType: "",
        PriceInfo: {
          SimPrice: 0,
          ESimPrice: 0
        }
      },
      // freeForm: {
      //     IsEsim: false,
      //     msin: "",
      //     Phone: "",
      //     SimPrice: "",
      // },
      listFreeSim: [],
      listTMDTSim: [],
      totalsTMDT: 0,
      totalsFreeSim: 0,
      listSimAndPack: [],
      listSimHistory: [],
      customerInfo: {
        FullName: "",
        ContactPhone: "",
        Email: "",
        Address: "",
        Note: "",
        Total: 0
      },
      successOrderId: "",
      file: null,
      fileResult: null,
      stock: "",
      listStatus: [
        {
          id: "0",
          text: "Sẵn sàng"
        },
        // {
        //     id: "1",
        //     text: "Chưa kích hoạt"
        // },
        // {
        //     id: "2",
        //     text: "Đã kích hoạt"
        // },
        {
          id: "10",
          text: "Giữ số"
        }
      ],
      changeStatusInfo: {
        phone: "",
        status: 0,
        tags: [],
        note: ""
      },
      exportNumber: 0
    };
  },
  methods: {
    onExportPhoneFile(e) {
      e.preventDefault();
      if (this.exportNumber < 0) {
        this.$toast.warning("Số bản ghi không hợp lệ!", {
          icon: true,
          closeButton: "button"
        });
        return;
      }
      if (this.stock == "TMDT") {
        if (this.exportNumber > this.totalsTMDT) {
          this.$toast.warning(
              "Số lượng thuê bao trong kho không còn đủ. Vui lòng kiểm tra lại.",
              {
                icon: true,
                closeButton: "button"
              }
          );
          return;
        }
        useJwt
            .get(
                `odata.svc/Inventory0Ds?%24filter=${this.getTMDTFilter()}&$top=${
                    this.exportNumber > 0 ? this.exportNumber : this.totalsTMDT
                }&$count=true`
            )
            .then(response => {
              const data = response.data.value.map(el => {
                if (el.Esim == 0 || el.Esim == 1) {
                  el.disabled = true;
                } else {
                  el.disabled = false;
                }

                return el;
              });
              this.exportExcel(
                  this.fieldsTMDTSim.filter(
                      el => el.field !== "action" && el.field !== "handle"
                  ),
                  data,
                  "file",
                  "xlsx",
                  "Sheet 1"
              );
              this.$bvModal.hide("modal-export-phone");
            });
      } else if (this.stock == "0D") {
        if (this.exportNumber > this.totalsFreeSim) {
          this.$toast.warning(
              "Số lượng thuê bao trong kho không còn đủ. Vui lòng kiểm tra lại.",
              {
                icon: true,
                closeButton: "button"
              }
          );
          return;
        }
        useJwt
            .get(
                `odata.svc/Inventory0Ds?%24filter=${this.getFreeSimFilter()}&$top=${
                    this.exportNumber > 0 ? this.exportNumber : this.totalsFreeSim
                }&$count=true`
            )
            .then(response => {
              const data = response.data.value;

              this.exportExcel(
                  this.fieldsFreeSim.filter(
                      el => el.field !== "action" && el.field !== "handle"
                  ),
                  data,
                  "file",
                  "xlsx",
                  "Sheet 1"
              );
              this.$bvModal.hide("modal-export-phone");
            });
      }
    },
    exportExcel(
        columns,
        data,
        name,
        fileType = "xlsx",
        sheetName = "SheetName"
    ) {
      let createXLSLFormatObj = [];
      let newXlsHeader = [];
      if (columns.length === 0) {
        return;
      }
      if (data.length === 0) {
        return;
      }
      columns.map(column => {
        newXlsHeader.push(column.label);
      });

      createXLSLFormatObj.push(newXlsHeader);
      data.map(value => {
        let innerRowData = [];
        columns.map(val => {
          let fieldValue = value[val.field];
          if (typeof val.field === "function") {
            fieldValue = this.getNestedValue(value, "Kol");
          } else if (val.field.split(".").length > 1) {
            fieldValue = this.getNestedValue(value, val.field);
          }
          if (val.dataFormat && typeof val.dataFormat === "function") {
            innerRowData.push(val.dataFormat(fieldValue));
          } else {
            innerRowData.push(fieldValue);
          }
        });
        createXLSLFormatObj.push(innerRowData);
      });

      let mfileName = `${name}.${fileType}`;

      let ws_name = sheetName;

      let wb = utils.book_new(),
          ws = utils.aoa_to_sheet(createXLSLFormatObj);
      utils.book_append_sheet(wb, ws, ws_name);
      writeFile(wb, mfileName);
    },
    getNestedValue(object, string) {
      string = string.replace(/\[(\w+)\]/g, ".$1");
      string = string.replace(/^\./, "");
      let a = string.split(".");
      for (let i = 0, n = a.length; i < n; ++i) {
        let k = a[i];
        if (k in object) {
          object = object[k];
        } else {
          return;
        }
      }
      return object;
    },
    onUploadFile() {
      let reader = new FileReader();

      reader.onload = async e => {
        let data = e.target.result;
        let workbook = read(data, {
          type: "binary"
        });

        let XL_row_object = utils.sheet_to_json(
            workbook.Sheets[workbook.SheetNames[0]]
        );
        const newData = XL_row_object.map(el => {
          return {
            Phone: el["Phone (*)"] || "",
            Status: el["Trạng thái"] || 0,
            Tags: el["Tag số"]
                ? el["Tag số"].split(",").map(el => el.trim())
                : []
          };
        });

        const results = [];
        for (const el of newData) {
          try {
            const result = await useOdata
                .patch(`odata.svc/Inventory0Ds('${el.Phone}')`, {
                  Status: +el.Status
                  // Tags: el.Tags,
                })
                .query();

            results.push("success");
          } catch (error) {
            results.push("fail");
          }
        }

        if (this.stock == "TMDT") {
          this.loadListTMDTSim();
        } else if (this.stock == "0D") {
          this.loadListFreeSim();
        }

        if (results.filter(el => el == "success").length === results.length) {
          this.$toast.success("Cập nhật trạng thái thuê bao thành công!", {
            icon: true,
            closeButton: "button"
          });
        } else if (
            results.filter(el => el == "fail").length === results.length
        ) {
          this.$toast.warning(
              "Vui lòng kiểm tra lại trạng thái của thuê bao!",
              {
                icon: true,
                closeButton: "button"
              }
          );
        } else {
          let numOfSuccess = results.filter(el => el == "success").length;
          let numOfFail = results.filter(el => el == "fail").length;

          this.$toast.warning(
              `Cập nhật trạng thái ${numOfSuccess} thuê bao thành công, ${numOfFail} thuê bao thất bại. Vui lòng kiểm tra lại trạng thái của thuê bao!`,
              {
                icon: true,
                closeButton: "button"
              }
          );
        }
      };

      reader.onerror = function (ex) {
        console.log(ex);
      };

      reader.readAsBinaryString(this.file);
    },
    onOpenModalImportPhone(value) {
      this.stock = value;
      this.file = null;
      this.$bvModal.show("modal-import-phone");
    },
    onOpenModalExportPhone(value) {
      this.stock = value;
      this.$bvModal.show("modal-export-phone");
    },
    onUpdatePhoneStatus(e) {
      e.preventDefault();
      useOdata
          .patch(`odata.svc/Inventory0Ds('${this.changeStatusInfo.phone}')`, {
            Status: +this.changeStatusInfo.status
            // Tags: this.changeStatusInfo.tags,
            // Note: this.changeStatusInfo.note
          })
          .query()
          .then(response => {
            this.$toast.success("Cập nhật trạng thái thuê bao thành công!", {
              icon: true,
              closeButton: "button"
            });
            this.$bvModal.hide("modal-change-status-phone");
            if (this.stock == "TMDT") {
              this.loadListTMDTSim();
            } else {
              this.loadListFreeSim();
            }
          });
    },
    onChangeStatusPhone(value, phone) {
      this.stock = value;

      let simInfo = null;
      if (this.stock == "TMDT") {
        simInfo = this.listTMDTSim.find(el => el.Phone == phone);
      } else {
        simInfo = this.listFreeSim.find(el => el.Phone == phone);
      }

      if (simInfo) {
        this.changeStatusInfo = {
          phone: simInfo.Phone,
          status: simInfo.Status,
          tags: simInfo.Tags || [],
          note: simInfo.Note || ""
        };
        this.$bvModal.show("modal-change-status-phone");
      }
    },
    downloadTemplate() {
      useJwt.get("ecommerce/download-template").then(result => {
        if (result?.data?.result) {
          const mediaType =
              "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,";
          var a = document.createElement("a");
          a.href = mediaType + result.data.result;
          a.download = "file.xlsx";
          a.textContent = "Download file!";
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        }
      });
    },
    downloadListPhoneTemplate(url) {
      const a = document.createElement("a");
      a.href = url;
      a.download = url.split("/").pop();
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
    downloadResult() {
      if (!this.fileResult) {
        this.$toast.warning("Không có file kết quả được tìm thấy!", {
          icon: true,
          closeButton: "button"
        });
        return;
      }
      const mediaType =
          "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,";
      var a = document.createElement("a");
      a.href = mediaType + this.fileResult;
      a.download = "file.xlsx";
      a.textContent = "Download file!";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
    handleChange(event) {
      this.file = event.target.files ? event.target.files[0] : null;
    },
    importExcelOk() {
      if (!this.file) {
        this.$toast.warning("Vui lòng chọn file!", {
          icon: true,
          closeButton: "button"
        });
        return;
      }
      if(this.isLoading){
        return;
      }
      const reader = new FileReader();
      reader.onloadend = () => {
        this.isLoading=true
        useJwt
            .post("ecommerce/import-file-excel", {
              file: reader.result.replace(
                  "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,",
                  ""
              )
            })
            .then(result => {
              this.isLoading=false
              this.fileResult = result.data.result;
              this.$toast.success("Tải lên thành công!", {
                icon: true,
                closeButton: "button"
              });
            })
            .catch(err => {
              this.isLoading=false
              this.$toast.warning(
                  err.response?.data?.message || "Tải lên thất bại!",
                  {
                    icon: true,
                    closeButton: "button"
                  }
              );
              this.fileResult = err.response?.data?.result;
            });
      };
      reader.readAsDataURL(this.file);
    },
    resetOrderData() {
      (this.rows = []),
          this.setCookie("e-commerce-info", JSON.stringify(this.customerInfo), 3);
    },
    setCookie(cname, cvalue, exdays) {
      const d = new Date();
      d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
      let expires = "expires=" + d.toUTCString();
      document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    },
    getCookie(cname) {
      let name = cname + "=";
      let decodedCookie = decodeURIComponent(document.cookie);
      let ca = decodedCookie.split(";");
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == " ") {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    },
    PrintImport(id) {
      useJwt
          .get("ecommerce/print-import/" + id)
          .then(res => {
            this.$toast.success(res.data.message, {
              icon: true,
              closeButton: "button"
            });
          })
          .catch(err => {
            this.$toast.warning(err.response?.data?.message || "In thất bại!", {
              icon: true,
              closeButton: "button"
            });
          });
    },
    DownloadImport(id) {
      useJwt
          .post("ecommerce/download-file-from-history", {Id: id})
          .then(res => {
            if (res?.data?.result) {
              const mediaType =
                  "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,";
              var a = document.createElement("a");
              a.href = mediaType + res.data.result;
              a.download = "file.xlsx";
              a.textContent = "Download file!";
              document.body.appendChild(a);
              a.click();
              document.body.removeChild(a);
            }
          })
          .catch(err => {
            console.log(err);
            this.$toast.warning(err.response?.data?.message || "Tải thất bại!", {
              icon: true,
              closeButton: "button"
            });
          });
    },
    onStoreEsimCheckChange() {
      if (this.websiteForm.IsEsim) {
        this.websiteForm.SimPrice = this.websiteForm.PriceInfo.ESimPrice;
      } else {
        this.websiteForm.SimPrice = this.websiteForm.PriceInfo.SimPrice;
      }
      this.$forceUpdate();
    },
    updateParamsFreeStore(newProps) {
      this.serverParamsListFreeSim = Object.assign(
          {},
          this.serverParamsListFreeSim,
          newProps
      );
    },
    onPageChangeFreeStore(params) {
      this.updateParamsFreeStore({page: params.currentPage});
      this.loadListFreeSim();
    },
    onPerPageChangeFreeStore(params) {
      this.updateParamsFreeStore({pageSize: params.currentPerPage});
      this.loadListFreeSim();
    },
    onSortChangeFreeStore(params) {
      this.updateParamsFreeStore({
        sort: params
      });
      this.loadListFreeSim();
    },
    onColumnFilterFreeStore(params) {
      this.updateParamsFreeStore(params);
      this.loadListFreeSim();
    },

    updateParamsTMDTStore(newProps) {
      this.serverParamsListTMDTSim = Object.assign(
          {},
          this.serverParamsListTMDTSim,
          newProps
      );
    },
    onPageChangeTMDTStore(params) {
      this.updateParamsTMDTStore({page: params.currentPage});
      this.loadListTMDTSim();
    },
    onPerPageChangeTMDTStore(params) {
      this.updateParamsTMDTStore({pageSize: params.currentPerPage});
      this.loadListTMDTSim();
    },
    onSortChangeTMDTStore(params) {
      this.updateParamsTMDTStore({
        sort: params
      });
      this.loadListTMDTSim();
    },
    onColumnFilterTMDTStore(params) {
      this.updateParamsTMDTStore(params);
      this.loadListTMDTSim();
    },

    updateParamsSimAndPack(newProps) {
      this.serverParamsListSimAndPack = Object.assign(
          {},
          this.serverParamsListSimAndPack,
          newProps
      );
    },
    updateParamsSimHistory(newProps) {
      this.serverParamsListSimHistory = Object.assign(
          {},
          this.serverParamsListSimAndPack,
          newProps
      );
    },
    onPageChangeSimAndPack(params) {
      this.updateParamsSimAndPack({page: params.currentPage});
      this.loadListSimAndPack();
    },
    onPageChangeSimHistory(params) {
      this.updateParamsSimHistory({page: params.currentPage});
      this.loadListSimHistory();
    },
    onPerPageChangeSimAndPack(params) {
      this.updateParamsSimAndPack({pageSize: params.currentPerPage});
      this.loadListSimAndPack();
    },
    onPerPageChangeSimHistory(params) {
      this.updateParamsSimHistory({pageSize: params.currentPerPage});
      this.loadListSimHistory();
    },
    onSortChangeSimAndPack(params) {
      this.updateParamsSimAndPack({
        sort: params
      });
      this.loadListSimAndPack();
    },
    onColumnFilterSimAndPack(params) {
      this.updateParamsSimAndPack(params);
      this.loadListSimAndPack();
    },
    onSelectFreeSim(phone) {
      this.listFreeSim = this.listFreeSim.map(el => {
        if (el.Phone == phone) {
          el.selected = !!!el.selected;
        }
        return el;
      });
    },
    onSelectTMDTSim(phone) {
      this.listTMDTSim = this.listTMDTSim.map(el => {
        if (el.Phone == phone) {
          el.selected = !!!el.selected;
        }
        return {
          ...el,
          Kol: el.Kol === 0 ? "" : el.Kol
        };
      });
    },
    onChangeSimTypeSim(phone) {
      this.listTMDTSim = this.listTMDTSim.map(el => {
        if (el.Phone == phone) {
          if (!!el.Esim) {
            el.Esim = 0;
          } else {
            el.Esim = 1;
          }
        }
        return {
          ...el,
          Kol: el.Kol === 0 ? "" : el.Kol
        };
      });
    },
    onSimAndPackQuantityChange(e, uuid) {
      this.listSimAndPack = this.listSimAndPack.map(el => {
        if (el.uuid == uuid) {
          el.Quantity = e;
        }
        return el;
      });
    },
    async onOrder() {
      if (this.rows.length == 0) {
        this.$toast.warning("Danh sách số rỗng", {
          icon: true,
          closeButton: "button"
        });
        return;
      }
      var validate = await this.$refs.modalCustomerInfo
          .validate()
          .then(success => {
            return success;
          });
      if (!validate) {
        this.$toast.warning("Vui lòng nhập các trường thông tin bắt buộc", {
          icon: true,
          closeButton: "button"
        });
        return;
      }
      if(this.isLoading){
        return
      }

      let channel = this.ecommerceChannelList.find(
          el => el.Id == this.selectedEcomerceChannel
      );
      let data = {
        FullName: this.customerInfo.FullName,
        ContactPhone: this.customerInfo.ContactPhone,
        Email: this.customerInfo.Email,
        Address: this.customerInfo.Address,
        Note: this.customerInfo.Note,
        SaleChannelCode: channel.Code,
        Details: this.rows.map(el => {
          return {
            Source: el.Source, //1: Kho online, 2 kho 0 đồng, 3 mua sim không kèm gói (chức năng chưa làm)
            Phone: el.Phone || "",
            IsEsim: el.IsEsim,
            Pack: el.Pack, //Dùng trong chức năng chưa làm
            Quantity: +el.Quantity || 1 //Dùng trong chức năng chưa làm
          };
        })
      };
      this.isLoading=true

      useJwt
          .post("ecommerce/create", data)
          .then(response => {
            this.isLoading=false
            this.successOrderId = response.data.result;
            this.$bvModal.show("modal-order-success");
            setTimeout(() => {
              this.$bvModal.hide("modal-order-success");
            }, 10000);
          })
          .catch(err => {
            this.isLoading=false
            this.$toast.error(err.response?.data?.message || "Tạo đơn thất bại", {
              icon: true,
              closeButton: "button"
            });
          });
    },
    async onAddSimAndPack(bvModalEvt) {
      bvModalEvt.preventDefault();

      for (let i = 0; i < this.listSimAndPack.length; i++) {
        const simInfo = this.listSimAndPack[i];
        if (simInfo.Quantity) {
          if (this.rows.find(el => el.uuid == simInfo.uuid)) {
            this.rows = this.rows.map(el => {
              if (el?.uuid === simInfo.uuid) {
                el.Quantity = simInfo.Quantity;
              }
              return el;
            });
          } else {
            this.rows.push({
              Phone: "",
              Msin: "",
              Price: 0,
              SimPrice: simInfo.SimPrice,
              Pack: simInfo.Pack || "",
              PackPrice: simInfo.PackPrice || 0,
              ThoiGianCamKet: simInfo.ThoiGianCamKet || 0,
              SimType: "",
              IsEsim: !!simInfo.IsEsim,
              Quantity: simInfo.Quantity,
              uuid: simInfo.uuid,
              Source: 3 //1: Kho online, 2 kho 0 đồng, 3 mua sim không kèm gói (chức năng chưa làm)
            });
          }
        }
      }

      this.$forceUpdate();
      this.$nextTick(() => {
        this.$bvModal.hide("modal-sim-and-pack");
      });
    },
    async onAddFreeSim(bvModalEvt) {
      bvModalEvt.preventDefault();

      let alreadyExistNums = 0;
      for (let i = 0; i < this.listFreeSim.length; i++) {
        const simInfo = this.listFreeSim[i];
        if (simInfo.selected) {
          if (!this.rows.find(el => el.Phone == simInfo.Phone)) {
            this.rows.push({
              Phone: simInfo.Phone,
              Msin: simInfo.msin ?? "",
              Price: simInfo.Price,
              SimPrice: !!simInfo.Esim ? simInfo.EsimPrice : simInfo.SimPrice,
              Pack: simInfo.Pack || "",
              PackPrice: simInfo.PackPrice || 0,
              ThoiGianCamKet: simInfo.ThoiGianCamKet || 0,
              SimType: "",
              IsEsim: !!simInfo.Esim,
              Quantity: 1,
              Source: 2 //1: Kho online, 2 kho 0 đồng, 3 mua sim không kèm gói (chức năng chưa làm)
            });
          } else {
            alreadyExistNums++;
          }
        }
      }

      // Issue2
      // if(alreadyExistNums){
      //     this.$toast.warning(`${alreadyExistNums} thuê bao đã tồn tại`, {
      //         icon: true,
      //         closeButton: "button",
      //     });
      // }

      this.$forceUpdate();
      this.$nextTick(() => {
        this.$bvModal.hide("modal-store-free");
      });
    },
    async onAddTMDTSim(bvModalEvt) {
      bvModalEvt.preventDefault();

      let alreadyExistNums = 0;
      for (let i = 0; i < this.listTMDTSim.length; i++) {
        const simInfo = this.listTMDTSim[i];
        if (simInfo.selected) {
          if (!this.rows.find(el => el.Phone == simInfo.Phone)) {
            this.rows.push({
              Phone: simInfo.Phone,
              Msin: simInfo.msin ?? "",
              Price: simInfo.Price,
              SimPrice: !!simInfo.Esim ? simInfo.EsimPrice : simInfo.SimPrice,
              Pack: simInfo.Pack || "",
              PackPrice: simInfo.PackPrice || 0,
              ThoiGianCamKet: simInfo.ThoiGianCamKet || 0,
              SimType: "",
              IsEsim: !!simInfo.Esim,
              Quantity: 1,
              Source: 4 // 4 kho tmdt
            });
          } else {
            alreadyExistNums++;
          }
        }
      }

      this.$forceUpdate();
      this.$nextTick(() => {
        this.$bvModal.hide("modal-store-tmdt");
      });
    },
    async onAddStoreSim(bvModalEvt) {
      bvModalEvt.preventDefault();
      var validate = await this.$refs.modalStoreWebsite
          .validate()
          .then(success => {
            return success;
          });
      if (!validate) {
        this.$toast.warning("Vui lòng nhập các trường thông tin bắt buộc", {
          icon: true,
          closeButton: "button"
        });
        return;
      }
      if (!this.rows.find(el => el.Phone == this.websiteForm.Phone)) {
        this.rows.push({
          Phone: this.websiteForm.Phone,
          Msin: this.websiteForm.msin,
          Price: this.websiteForm.Price,
          SimPrice: this.websiteForm.SimPrice,
          Pack: this.websiteForm.Pack,
          PackPrice: this.websiteForm.PackPrice,
          ThoiGianCamKet: this.websiteForm.ThoiGianCamKet,
          SimType: this.websiteForm.SimType,
          IsEsim: !!this.websiteForm.IsEsim,
          Quantity: 1,
          Source: 1 //1: Kho online, 2 kho 0 đồng, 3 mua sim không kèm gói (chức năng chưa làm)
        });
      } else {
        this.$toast.warning("Thuê bao đã tồn tại", {
          icon: true,
          closeButton: "button"
        });
        return;
      }
      this.$bvModal.hide("modal-store-website");
    },
    async deletePhone(phone, uuid) {
      let resModal = await this.$bvModal.msgBoxConfirm(
          "Vui lòng xác nhận bạn muốn xoá số điện thoại",
          {title: "Please Confirm", size: "sm", centered: true}
      );
      if (resModal) {
        if (phone) {
          this.rows = this.rows.filter(el => el?.Phone != phone);
          this.listFreeSim = this.listFreeSim.map(el => {
            if (el.Phone == phone) {
              el.selected = false;
            }
            return el;
          });
          this.listTMDTSim = this.listTMDTSim.map(el => {
            if (el.Phone == phone) {
              el.selected = false;
            }
            return {
              ...el,
              Kol: el.Kol === 0 ? "" : el.Kol
            };
          });
        }
        if (uuid) {
          this.rows = this.rows.filter(el => el?.uuid != uuid);
        }
      }
    },
    loadListEcommerceChannel() {
      useJwt
          .get("odata.svc/SaleChannels?%24filter=IsEcommerce%20eq%20true")
          .then(response => {
            this.ecommerceChannelList = response.data.value;
            if (this.ecommerceChannelList.length > 0) {
              this.selectedEcomerceChannel = this.ecommerceChannelList[0].Id;
            }
          });
    },
    getFreeSimFilter() {
      let filter = `(Stock eq '0D')`;
      let filterKeys = Object.keys(this.serverParamsListFreeSim.columnFilters);
      filterKeys.forEach(el => {
        if (el == "Phone" && this.serverParamsListFreeSim.columnFilters[el]) {
          filter += ` and (contains(tolower(Phone),'${this.serverParamsListFreeSim.columnFilters[el]}'))`;
        }
        if (el == "Msin" && this.serverParamsListFreeSim.columnFilters[el]) {
          filter += ` and (contains(tolower(Msin),'${this.serverParamsListFreeSim.columnFilters[el]}'))`;
        }
        if (el == "Price" && this.serverParamsListFreeSim.columnFilters[el]) {
          filter += ` and (Price eq ${this.serverParamsListFreeSim.columnFilters[el]})`;
        }
        if (
            el == "PackPrice" &&
            this.serverParamsListFreeSim.columnFilters[el]
        ) {
          filter += ` and (PackPrice eq ${this.serverParamsListFreeSim.columnFilters[el]})`;
        }
        if (el == "Pack" && this.serverParamsListFreeSim.columnFilters[el]) {
          filter += ` and contains(tolower(Pack),'${this.serverParamsListFreeSim.columnFilters[el]}')`;
        }
        if (
            el == "Esim" &&
            this.serverParamsListFreeSim.columnFilters[el] > 0
        ) {
          filter += ` and (Esim eq ${
              this.serverParamsListFreeSim.columnFilters[el] == 2
                  ? "true"
                  : "false"
          })`;
        }
        if (
            el == "EsimPrice" &&
            this.serverParamsListFreeSim.columnFilters[el]
        ) {
          filter += ` and (EsimPrice eq ${this.serverParamsListFreeSim.columnFilters[el]})`;
        }
        if (
            el == "SimPrice" &&
            this.serverParamsListFreeSim.columnFilters[el]
        ) {
          filter += ` and (SimPrice eq ${this.serverParamsListFreeSim.columnFilters[el]})`;
        }
        if (
            el == "Status" &&
            this.serverParamsListFreeSim.columnFilters[el] != 99
        ) {
          filter += ` and (Status eq ${this.serverParamsListFreeSim.columnFilters[el]})`;
        }
      });
      return filter;
    },
    loadListFreeSim() {
      useJwt
          .get(
              `odata.svc/Inventory0Ds?%24filter=${this.getFreeSimFilter()}&$top=${
                  this.serverParamsListFreeSim.pageSize
              }&$skip=${(this.serverParamsListFreeSim.page - 1) *
              this.serverParamsListFreeSim.pageSize}&$count=true`
          )
          .then(response => {
            this.listFreeSim = response.data.value;
            this.totalsFreeSim = response.data["@odata.count"] ?? 0;
          });
    },
    getTMDTFilter() {
      let filter = `(Stock eq 'TMĐT')`;
      let filterKeys = Object.keys(this.serverParamsListTMDTSim.columnFilters);
      filterKeys.forEach(el => {
        if (el == "Phone" && this.serverParamsListTMDTSim.columnFilters[el]) {
          filter += ` and (contains(tolower(Phone),'${this.serverParamsListTMDTSim.columnFilters[el]}'))`;
        }
        if (el == "Msin" && this.serverParamsListTMDTSim.columnFilters[el]) {
          filter += ` and (contains(tolower(Msin),'${this.serverParamsListTMDTSim.columnFilters[el]}'))`;
        }
        if (el == "Price" && this.serverParamsListTMDTSim.columnFilters[el]) {
          filter += ` and (Price eq ${this.serverParamsListTMDTSim.columnFilters[el]})`;
        }
        if (
            el == "PackPrice" &&
            this.serverParamsListTMDTSim.columnFilters[el]
        ) {
          filter += ` and (PackPrice eq ${this.serverParamsListTMDTSim.columnFilters[el]})`;
        }
        if (el == "Pack" && this.serverParamsListTMDTSim.columnFilters[el]) {
          filter += ` and contains(tolower(Pack),'${this.serverParamsListTMDTSim.columnFilters[el]}')`;
        }
        if (
            el == "EsimPrice" &&
            this.serverParamsListTMDTSim.columnFilters[el]
        ) {
          filter += ` and (EsimPrice eq ${this.serverParamsListTMDTSim.columnFilters[el]})`;
        }
        if (
            el == "SimPrice" &&
            this.serverParamsListTMDTSim.columnFilters[el]
        ) {
          filter += ` and (SimPrice eq ${this.serverParamsListTMDTSim.columnFilters[el]})`;
        }
        if (
            el == "Esim" &&
            this.serverParamsListTMDTSim.columnFilters[el] != 2
        ) {
          filter += ` and (Esim eq ${
              this.serverParamsListTMDTSim.columnFilters[el] == 1
                  ? "true"
                  : "false"
          })`;
        }
        if (
            el == "Status" &&
            this.serverParamsListTMDTSim.columnFilters[el] &&
            this.serverParamsListTMDTSim.columnFilters[el] != 99
        ) {
          filter += ` and (Status eq ${this.serverParamsListTMDTSim.columnFilters[el]})`;
        }
        if (el == "Months" && this.serverParamsListTMDTSim.columnFilters[el]) {
          filter += ` and (Months eq ${this.serverParamsListTMDTSim.columnFilters[el]})`;
        }
        if (el == "SimType" && this.serverParamsListTMDTSim.columnFilters[el]) {
          filter += ` and (SimType eq ${this.serverParamsListTMDTSim.columnFilters[el]})`;
        }
        if (
            el == "Kol" &&
            this.serverParamsListTMDTSim.columnFilters[el] != ""
        ) {
          filter += ` and (Kol eq ${this.serverParamsListTMDTSim.columnFilters[el]})`;
        }
      });

      return filter;
    },
    loadListTMDTSim() {
      useJwt
          .get(
              `odata.svc/Inventory0Ds?%24filter=${this.getTMDTFilter()}&$top=${
                  this.serverParamsListTMDTSim.pageSize
              }&$skip=${(this.serverParamsListTMDTSim.page - 1) *
              this.serverParamsListTMDTSim.pageSize}&$count=true`
          )
          .then(response => {
            this.listTMDTSim = response.data.value.map(el => {
              if (el.Esim == 0 || el.Esim == 1) {
                el.disabled = true;
              } else {
                el.disabled = false;
              }

              return {
                ...el,
                Kol: el.Kol === 0 ? "" : el.Kol
              };
            });
            this.totalsTMDT = response.data["@odata.count"] ?? 0;
          });
    },
    loadListSimAndPack() {
      useJwt.get(`ecommerce/package-list`).then(response => {
        this.listSimAndPack = response.data.result.map(el => {
          el.uuid = uuidv4();
          el.Quantity = 0;
          return el;
        });
      });
    },
    loadListSimHistory() {
      useJwt.get(`ecommerce/import-history`).then(response => {
        this.listSimHistory = response.data.result.map(el => {
          el.ImportDate = moment(el.ImportDate).format("DD/MM/YYYY HH:mm:ss");
          return el;
        });
      });
    },
    handleMessageEventer(e) {
      let key = e.message ? "message" : "data";
      let data = e[key];

      if (typeof data == "object") {
        if (data.type == "onChooseSim") {
          this.$bvModal.hide("popupChooseSim");
          this.websiteForm = {
            IsEsim: this.websiteForm.IsEsim,
            Phone: data.data.Phone,
            contactPhone: "",
            Price: data.data.Price,
            SimPrice: this.websiteForm.IsEsim
                ? data.data.ESimPrice || 0
                : data.data.SimPrice || 0,
            Pack: data.data.Pack,
            PackPrice: data.data.PackPrice,
            ThoiGianCamKet: data.data.ThoiGianCamKet,
            SimType: data.data.SimType,
            PriceInfo: {
              SimPrice: data.data.SimPrice || 0,
              ESimPrice: data.data.EsimPrice || 0
            }
          };
        }
      }
    },
    openChooseSimPopup() {
      this.$bvModal.show("popupChooseSim");
    },
    onOpenModalWeb() {
      this.$bvModal.show("modal-store-website");
      this.websiteForm = {
        IsEsim: false,
        Phone: "",
        contactPhone: "",
        Price: 0,
        SimPrice: 0,
        Pack: "",
        PackPrice: "",
        ThoiGianCamKet: 0,
        SimType: "",
        PriceInfo: {
          SimPrice: 0,
          ESimPrice: 0
        }
      };
    },
    onOpenModalSimAndPack() {
      this.$bvModal.show("modal-sim-and-pack");
      this.listSimAndPack = this.listSimAndPack.map(el => {
        el.Quantity = 0;
        return el;
      });
    },
    onOpenModalImportFile() {
      this.file = null;
      this.fileResult = null;
      this.$bvModal.show("modal-import-excel");
    },
    onOpenModalImportHistory() {
      this.loadListSimHistory();
      this.$bvModal.show("modal-import-history");
    },
    onOpenModalFree() {
      this.$bvModal.show("modal-store-free");
    },
    onOpenModalTMDT() {
      this.$bvModal.show("modal-store-tmdt");
    }
  }
};
</script>
<style lang="scss">
.tags-container {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;

  .tag-item {
    border-color: #ed1f24 !important;
    background-color: #ed1f24 !important;
    border: 1px solid transparent;
    padding: 0.3rem 1rem;
    border-radius: 0.358rem;
    text-align: center;
    color: white;
  }
}

.export-phone-note {
  font-style: italic;
  font-weight: 400;
  text-align: justify;

  .text-note {
    font-weight: 600;
  }
}

.group-number-of-phone {
  display: flex;
  gap: 12px;
  align-items: center;

  .number-label {
    white-space: nowrap;
  }

  .form-control {
    flex: auto;
  }
}

.error-txt small {
  color: red;
}

.form-group .form-custom-label {
  color: #000000;
  font-size: 1rem;
}

.form-group .form-custom-horizontal {
  display: flex;
  align-items: center;
  gap: 12px;
}

.form-group label:not(.form-control),
.form-group .col-form-label {
  color: #000000;
  font-size: 1rem;
}
</style>
